module.exports = __webpack_public_path__ + "assets/img/14.d747d160.png";